export default __webpack_public_path__ + "static/media/eraser.2d3e67f9.svg";